import { useState } from 'react';

// Reprice search-mode chooser (spec docs/specs_20260708_verbatim-reprice.md):
// Verbatim (operator's item name, searched exactly) vs Automatic (engine derives).
// Options only — no free-text query. Verbatim is always preselected.
export default function RepriceDialog({ items, scope, onCancel, onConfirm }) {
    const [mode, setMode] = useState('verbatim');
    const verbatimOk = items.some(it => (it.name || '').trim().length > 0);
    const disabled = mode === 'verbatim' && !verbatimOk;

    return (
        <div className="modal-overlay">
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{scope === 'quote' ? 'Reprice quote' : 'Reprice item'}</h2>
                    <button className="modal-close" onClick={onCancel}>&times;</button>
                </div>
                <div className="modal-body-scroll">
                    <label className="qa-reprice-opt">
                        <input type="radio" name="reprice-mode" value="verbatim"
                            checked={mode === 'verbatim'} onChange={() => setMode('verbatim')} />
                        <span><strong>Search my item name verbatim</strong> — the exact string{items.length > 1 ? 's' : ''} below hit{items.length > 1 ? '' : 's'} eBay/Reverb/Google:</span>
                    </label>
                    <ul className="qa-reprice-names">
                        {items.map((it, i) => <li key={i}>{it.name}</li>)}
                    </ul>
                    <label className="qa-reprice-opt">
                        <input type="radio" name="reprice-mode" value="auto"
                            checked={mode === 'auto'} onChange={() => setMode('auto')} />
                        <span><strong>Automatic</strong> — engine derives the query.
                            {items.some(it => it.lastTerm) && (
                                <span className="qa-muted"> Last search{items.length > 1 ? 'es' : ''}: {items.filter(it => it.lastTerm).map(it => `"${it.lastTerm}"`).join(', ')}</span>
                            )}
                        </span>
                    </label>
                </div>
                <div className="modal-footer" style={{ padding: 'var(--space-4)' }}>
                    <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    <button className="btn btn-accent" disabled={disabled} onClick={() => onConfirm(mode)}>⟲ Reprice</button>
                </div>
            </div>
        </div>
    );
}
